// extracted by mini-css-extract-plugin
export default {"residency":"ArtistResidencyContainer-module_residency__WKhwx"};